import { render, staticRenderFns } from "./Reclamos.vue?vue&type=template&id=27cd32d6&scoped=true"
import script from "./Reclamos.vue?vue&type=script&lang=js"
export * from "./Reclamos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cd32d6",
  null
  
)

export default component.exports